<template>
  <v-autocomplete
    :value="value"
    :items="regionsList"
    :label="label"
    :search-input.sync="search"
    :error-messages="errorMessages"
    :rules="rules"
    :readonly="readonly"
    item-value="id"
    item-text="name"
    clearable
    multiple
    chips
    small-chips
    deletable-chips
    :counter="regionsList.length"
    v-bind="$attrs"
    v-on="listeners"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggle">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('ITEM.ALL') }} {{ $t('REGIONS.ITEMS') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapCacheActions } from 'vuex-cache';
import clearableSelectFilter from '@/modules/plannings/components/filters/mixins/clearableSelectFilter';

export default {
  name: 'RegionInput',

  mixins: [clearableSelectFilter],

  props: {
    value: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    rules: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      regionsList: []
    };
  },

  computed: {
    issetValue() {
      return this.value.length > 0;
    },
    isSelectedAll() {
      return this.regionsList.length === this.value.length;
    },
    allRegionsValue() {
      return this.regionsList.map(({ id }) => id);
    },
    isSomeSelected() {
      return this.issetValue && !this.isSelectedAll;
    },
    icon() {
      if (this.isSelectedAll) return 'mdi-close-box';
      if (this.isSomeSelected) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    }
  },

  mounted() {
    this.retrieveRegions().then(({ data }) => {
      this.regionsList = data.data;
    });
  },

  methods: {
    ...mapCacheActions('region', ['retrieveRegions']),
    toggle() {
      if (this.isSelectedAll) {
        this.emitter([]);
      } else {
        this.emitter(this.allRegionsValue);
      }
    }
  }
};
</script>

<style scoped></style>
